
import { useEffect } from 'react';
import { analytics, EventName } from '../services/analytics';

export const useAnalytics = () => {

    // Auto-init on mount if needed
    useEffect(() => {
        analytics.init();
    }, []);

    const track = (name: EventName, props: any = {}) => {
        analytics.trackEvent(name, props);
    };

    const identify = (userId: string, traits: any = {}) => {
        analytics.identifyUser(userId, traits);
    };

    return { track, identify };
};
